export const bookPageRows = 30;
export const bookRowsPerPageOptions = [30, 50, 100, 200];
